<template>
  <div class="container">
    <div class="main-content">
      <div class="topList">
        <div class="list">
          <div class="item" v-for="(item, index) in items" :key="index" v-on:click="onClickItem(index)">
            <label class="title" v-bind:class="{
              active: index === currentIndex,
            }">{{ getTitle(item) }}</label>
          </div>
        </div>
      </div>

      <div class="top-wrapper">
        <flex-line class="input-wrapper" v-if="currentIndex === 0" :show-border="true">
          <span class="field-name">
            {{ $t('Username / Email / Phone Number') }}
          </span>
          <div class="field-line-right" slot="right">
            <input v-model="username" :placeholder="$t('Please enter')" type="text" />
          </div>
        </flex-line>

        <flex-line v-if="currentIndex !== 0" class="input-wrapper" :show-border="true">
          <input v-model="mobileusername" :placeholder="$t('Enter Phone Number')"
            :attr="{ oninput: 'if(value.length>11)value=value.slice(0,11)' }" type="text" />
        </flex-line>

        <flex-line v-if="currentIndex !== 0" class="input-wrapper" :show-border="true">
          <input v-model="code" :placeholder="$t('Enter SMS Code')" type="number"
            :attr="{ oninput: 'if(value.length>6)value=value.slice(0,6)' }" />
          <div slot="right" class="common-btn send-btn" @click="sendVerifyCodeMobile">{{ sendStateTextMobile }}</div>
        </flex-line>

        <flex-line v-if="currentIndex === 0" class="input-wrapper" :show-border="true" :showPassword="showPassword"
          :toggleVisibility="toggleVisibility" :isPassword="true">
          <span class="field-name">
            {{ $t('Enter Password') }}
          </span>
          <div class="field-line-right" slot="right">
            <input class="field-input" :type="showPassword ? 'text' : 'password'" v-model="password"
              :placeholder="$t('Please enter')" />
          </div>
        </flex-line>
        <flex-line class="input-wrapper">
          <span class="field-name">
            {{ $t('Verification Code') }}
          </span>
          <div class="field-line-right" slot="right" style="display: flex;align-items: center;">
            <input class="field-input" type="text" v-model="captcha" :placeholder="$t('Please enter')" />
            <img v-if="captcha_img" :src="captcha_img" alt="captcha_img" @click="makecode_">
          </div>
        </flex-line>
      </div>
      <div class="retrieve-wrapper">
        <span class="retrieve-item" @click="onRetrieve">{{ $t('Forgot Password') }}?</span>
        <span class="retrieve-item" @click="onSignup">{{ $t('Sign Up') }}</span>
      </div>
      <div style="display:flex;justify-content: space-between;">
        <div class="common-btn ds-button-large" @click="signin">
          {{ $t('Login') }}
        </div>
        <div class="common-btn guest-login ds-button-large" @click="guestLogin">
          Guest Login
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login, wechatLogin, LoginByMobile, getThirdLogin, makecode } from '../../../api/memberLogin'
import { change_lang } from '../../../api/homeindex'
import { auto_register } from "../../../api/memberRegister";
import { loadScript } from '../../../util/common'
import { getSmsCaptcha, checkPictureCaptcha } from '../../../api/common'
import { Indicator, Toast } from 'mint-ui'
import { mapMutations, mapActions, mapState } from 'vuex'
import flexLine from '../../flexLine'

export default {
  name: 'Login',
  data() {
    return {
      ifLoaded: false,
      uniapp: 0,
      code: '',
      verifyCodeMobile: '',
      canSendMobile: true,
      timeIntervalMobile: false,
      sendStateTextMobile: this.$t('send'),
      mobileusername: '',
      username: '',
      password: '', // 定义密码
      currentIndex: 0,
      items: [
        {
          id: 1,
          title: 'Login'
        },
      ],
      showPassword: false,
      captcha_name: '',
      captcha_img: '',
      captcha: '' // 验证码输入
    }
  },
  components: { flexLine },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      vm.utils.setCookie('referrer', encodeURIComponent(from.fullPath), 1 / 24)
    })
  },
  computed: {
    ...mapState({
      inviter_id: state => state.member.inviterId,
      config: state => state.config.config
    })
  },
  watch: {
    mobileusername(newVal, oldVal) {
      // 只允许数字输入
      newVal = newVal.replace(/[^\d]/g, '')
      if (!newVal) {
        this.$nextTick(() => {
          this.mobileusername = newVal
        })
      }
    },
    ifLoaded(newVal, oldVal) {
      if (newVal) {
        let _this = this
        uni.getEnv(function (res) {
          if (res.plus) {
            _this.uniapp = 1
          }
        })
      }
    },
  },
  beforeDestroy: function () {
    clearInterval(this.timeIntervalMobile)
  },
  created: function () {
    // 预加载图片
    this.utils.preloadImages(['https://file.goshop.shop/static/box/1.gif', 'https://file.goshop.shop/static/box/2.gif'])
    let _this = this
    loadScript('uniapp', 'https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js', function () {
      _this.ifLoaded = true
    })
    Indicator.close()

    if (this.$route.query.clear) {
      this.memberLogout()
    }
    this.fetchConfig({}).then(
      res => {
        var config = res.result.config_list
        if (config.sms_login == 1) {
          this.items.push({ id: 2, title: 'phone login' })
        }
      },
      error => {
        Toast(error.message)
      }
    )
  },
  mounted() {
    const savedUsername = localStorage.getItem('lastUsername');
    if (savedUsername) this.username = savedUsername;
    this.makecode_()
    let isTokenInvalid = this.$route.params.isTokenInvalid
    if (isTokenInvalid) {
      Toast(this.$t('Login Expired'))
    }
  },
  methods: {
    ...mapMutations({
      saveAuthInfo: 'memberLogin',
      saveSellerAuthInfo: 'sellerLogin',
      memberLogout: 'memberLogout'
    }),
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    //游客登录
    guestLogin(){
      window.location.href = 'https://www.trygobuy.com/member/index'
    },
    makecode_() {
      makecode().then(res => {
        if (res.code == 10000) {
          this.captcha_name = res.result.captcha_name
          this.captcha_img = res.result.img
        }
      })
    },
    setLang() {
      // 跳转到语言设置页面
      this.$router.push({ name: 'HomeLang' })
    },
    toggleVisibility() {
      // 切换密码可见性
      this.showPassword = !this.showPassword;
    },
    sendVerifyCodeMobile() {
      if (!this.mobileusername) {
        Toast(this.$t('Please enter your phone number first'))
        return
      }
      if (!this.canSendMobile) {
        return
      }
      getSmsCaptcha(2, this.mobileusername).then(res => {
        this.canSendMobile = false
        let second = 60
        Toast(res.message)
        let _this = this
        this.timeIntervalMobile = setInterval(function () {
          if (second <= 0) {
            _this.canSendMobile = true
            _this.sendStateTextMobile = _this.$t('send')
            clearInterval(_this.timeIntervalMobile)
          } else {
            _this.sendStateTextMobile = second + 's'
          }
          second--
        }, 1000)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    getTitle(item) {
      return item ? this.$t(item.title) : ''
    },
    isShowLine(index) {
      return index === this.currentIndex
    },
    onClickItem(index) {
      if (index === 1) {
        let url = env.SITE_URL + '/member/login'
        window.open(url);
      }
      return
    },
    change_lang() {
      let lang = this.utils.fetch('lang')
      change_lang(lang)
    },
    signin() {
      if (this.currentIndex == 0) {
        // 使用用户名/密码登录
        let username = this.username
        let password = this.password
        let captcha = this.captcha
        let captcha_name = this.captcha_name
        if (username.length === 0) {
          Toast(this.$t('Please enter your username/email/phone number'))
          return
        }
        if (password.length === 0) {
          Toast(this.$t('Please enter your password'))
          return
        }
        if (password.length < 6) {
          Toast(this.$t('Password must be at least 6 characters'))
          return
        }
        Indicator.open()
        login(username, password, captcha, captcha_name).then(
          response => {
            Indicator.close()
            if (response.code == 10000) {
              this.saveAuthInfo({ token: response.result.token, info: response.result.info })
              this.change_lang()
              if (response.result.seller_info) {
                this.saveSellerAuthInfo({ token: response.result.seller_token, info: response.result.seller_info })
              }
              localStorage.setItem('lastUsername', username);
              this.goHome()
              localStorage.setItem('all_usd_list','')
              localStorage.setItem('usd_list','')
            } else {
              this.makecode_()
              Toast(response.message)
            }
          },
          error => {
            this.makecode_()
            Indicator.close()
            Toast(error.message)
          }
        )
      } else {
        // 使用手机号和验证码登录
        let mobileusername = this.mobileusername
        if (mobileusername.length != 11) {
          Toast(this.$t('Please enter an 11-digit phone number'))
          return
        }
        Indicator.open()
        LoginByMobile(mobileusername, this.code).then(
          response => {
            Indicator.close()
            this.saveAuthInfo({ token: response.result.token, info: response.result.info })
            if (response.result.seller_info) {
              this.saveSellerAuthInfo({ token: response.result.seller_token, info: response.result.seller_info })
            }
            this.goHome()
          },
          error => {
            Indicator.close()
            Toast(error.message)
          }
        )
      }
    },
    goBack() {
      let isFromInfoEdit = this.$route.params.isFromInfoEdit
      let isFromShare = this.$route.params.isFromShare
      if (isFromInfoEdit || isFromShare) {
        this.$router.push('home')
      } else {
        this.$router.go((this.$route.query.clear) ? -2 : -1)
      }
    },
    goHome() {
      let referrer = this.getReferrer()
      if (referrer) { // 返回之前的页面
        referrer = decodeURIComponent(referrer)
        this.utils.clearCookie('referrer')
        this.$router.replace({ path: referrer })
      } else {
        this.$router.replace({ name: 'HomeIndex' })
      }
    },
    getReferrer() {
      let referrer = this.$route.query.referrer
      if (!referrer) {
        referrer = this.utils.getCookie('referrer')
      }
      if (referrer && (referrer.search('memberlogin') != -1 || referrer.search('memberregister') != -1 || referrer.search('memberbind') != -1)) {
        referrer = '/member/index'
      }
      return referrer
    },
    onSignup() {
      this.$router.push({ name: 'HomeMemberRegister' })
    },
    onRetrieve() {
      this.$router.push({ name: 'HomeMemberForget' })
    },
    onWechat() {
      if (!this.ifLoaded) {
        Toast(this.$t('Please wait for the file to finish loading'))
        return
      }
      let referrer = this.getReferrer()
      if (referrer) { // 返回之前的页面
        referrer = decodeURIComponent(referrer)
      }
      if (this.uniapp) {
        uni.redirectTo({ url: 'login?inviter_id=' + this.inviter_id + '&ret_url=' + encodeURIComponent(referrer) })
        return
      }
      let ref = encodeURIComponent(referrer)
      wechatLogin(ref, this.inviter_id).then(res => {
        window.location.href = res.result
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.guest-login {
  background: unset !important;
  border: 1px #E7010C solid;
  color: #E7010C;
}
.bottom-btn {
  width: 100%;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.4rem;
  box-sizing: border-box;

  .retrieve-item {
    font-size: 1.4rem;
    font-weight: 600;
  }
}

.ds-button-large {
  width: 180px;
  margin: 2rem auto 0;
  background: #E7010C;
  padding: .2rem;
}

.lang {
  position: fixed;
  top: 15px;
  right: 15px;
  z-index: 99;

  img {
    width: 1.5rem;
  }
}

.logo {
  padding: 0.5rem 0;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 5rem;
    height: 5rem;
    display: block;
  }
}

.common-header {
  .btn {
    background: #000;
    color: #fff;
    box-shadow: 0px 2px 4px #d2d2d2;
  }
}


.container {

  background: #fff;
  padding-top: 2rem;
  box-sizing: border-box;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;

  .main-content {
    width: 400px;
    margin: auto;
    background: #fff;
    padding: 0 0 1rem 0;
  }

  .countdown {
    min-width: 4rem;
  }

  .send-btn {
    border: 1px solid $primaryColor;
    color: $primaryColor;
    min-width: 2rem
  }

  .top-wrapper {
    .input-wrapper {
      display: flex;
      align-content: center;
      align-items: center;
      background-color: #fff;

      img {
        height: 1.75rem;
        width: auto;
        margin: 0;
        padding: 0;
      }

      input {
        flex: 1;
        font-size: $subFontSize;
      }
    }

    .input-wrapper {
      display: flex;
      flex-direction: row;
      align-content: flex-start;
      align-items: center;
      background-color: #fff;

      flex-direction: column;
      align-items: flex-start;
      margin: .4rem 0;

      .field-name {
        width: 100%;
        font-size: 14px;
        font-weight: 600;
        margin: .5rem 0;
      }

      input {
        box-sizing: border-box;
        flex: 1;
        font-size: $subFontSize;
        flex: 1;
        width: 100%;
        text-align: left;
        padding: .9rem;
        border-radius: .4rem;
        background: #FAFAFA;
        border-radius: 5px 5px 5px 5px;
      }

      .bottom-input {
        border-bottom-width: 0;
      }

      .field-line-right {
        width: 100%;
        position: relative;
        img{cursor: pointer;}
      }

      ::v-deep(.right) {
        width: 100%;
      }
    }
  }
}

.retrieve-wrapper {
  margin: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: $h2;
  color: #000;
  font-weight: 600;
  span{cursor: pointer;}
}

.bottom-wrapper {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
  align-items: stretch;
}

.auth-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 13rem;
}

.auth-title-wrapper {
  height: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 2rem;
  margin-top: 1rem;
}

.auth-title {
  color: $descTextColor;
  font-size: $subFontSize;
}

.auth-line {
  display: flex;
  flex: 1;
  height: 1px;
  background-color: #eee;
  margin-left: 0.8rem;
  margin-right: 0.8rem;
}

.auth-item {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.auth-item-icon {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: #fff;
  font-size: 3rem;
  box-shadow: 0px 4px 4px #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;

  .icon {
    width: 60%;
  }
}

.auth-item-title {
  margin-top: 0.6rem;
  color: $formInputColor
}

.auth-bottom-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  margin-bottom: 1rem;
}

.topList {
  padding: .5rem 1.5rem 2rem;

  .list {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: stretch;
    background-color: #fff;
  }

  .item {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 1rem;
  }

  .title {
    text-align: center;
    font-size: 1.4rem;
    font-weight: 600;
    color: $formInputColor;
    cursor: pointer;
  }

  .title:hover,
  .active {
    color: #e7010c;
    font-weight: 600;
  }

  .normal {
    color: #404245;
  }

}

.top-wrapper {
  margin: 0 1rem;
}

::v-deep .flex-line {
  .right {
    width: 0;
  }
}
</style>
